import React, { useContext, useEffect } from "react"

import { UserContext } from '../utils/usermanagement'
import { ParentAPIContext } from "../utils/parentapi"

const LastLogin = () => {
  const [userState, userDispatch] = useContext(UserContext);
  const {parentAPI, parentChildren} = useContext(ParentAPIContext);
  const [parentAPIState, setParentAPIState] = parentAPI;

  useEffect(() => {
    const loginTime = userState?.cognito_user?.signInUserSession?.idToken?.payload?.auth_time

    if(loginTime) {
      const loginDate = loginTime ? new Date(loginTime * 1000).toISOString() : "";

      if(sessionStorage?.last_login != loginDate) {
        sessionStorage.last_login = loginDate;
        setParentAPIState({ action: 'update-login-time', data: null });
      }
  
      // if(parentAPIState) {
      //   if(parentAPIState.action === 'update-login-time-success') {
      //     console.log("Last Login update: " + JSON.stringify(parentAPIState.action));
      //   }
      // }  
    }
  }, [userState])

  return(<></>)
}

export default LastLogin
